import type { FundType } from "@/data/types";

/**
 * Bundled, type-appropriate default card image (lives in apps/web/public/).
 *
 * Used both when a fund has no image key AND when its CloudFront image 404s
 * (Bug #5: ~88 funds have DDB imageKeys whose S3 objects don't exist). Adding a
 * new fund type is a ONE-LINE entry here.
 *
 * CAVEAT: only `leveraged-card.webp`, `thematic-card.webp`, and the generic
 * `fund-card-default.webp` actually exist in public/images/etf/. `buffer` and
 * `fixed` deliberately point at the generic default so the fallback never 404s.
 */
const GENERIC_DEFAULT_CARD_IMAGE = "/images/etf/fund-card-default.webp";

const TYPE_DEFAULT_CARD_IMAGE: Record<FundType, string> = {
  leveraged: "/images/etf/leveraged-card.webp",
  thematic: "/images/etf/thematic-card.webp",
  buffer: GENERIC_DEFAULT_CARD_IMAGE,
  fixed: GENERIC_DEFAULT_CARD_IMAGE,
};

/** Resolve the bundled default card image for a fund type. */
export function typeDefaultCardImage(fundType: FundType): string {
  return TYPE_DEFAULT_CARD_IMAGE[fundType] ?? GENERIC_DEFAULT_CARD_IMAGE;
}
